import React from "react";
import UserControlComp from "../components/userControlComp/UserControlComp";

const UserControl = () => {
  return (
    <section>
      <h2 className="title">User Management</h2>
      <UserControlComp />
    </section>
  );
};

export default UserControl;
